module.exports = __webpack_public_path__ + "static/media/skill5_neg_es.3d705fdc.txt";